import { useEffect, useState } from "react";

import "./style.css";

import icon_deviantart from '../../assets/img/icon deviantart.png'
import icon_yt from '../../assets/img/icon YT.png'
import icon_email from '../../assets/img/icon email.png'
import icon_facebook from '../../assets/img/icon facebook.png'
import icon_insta from '../../assets/img/icon insta.png'
import icon_threads from '../../assets/img/icon threads.png'

function Loader({ setShowLoader }) {
    const [counter, setCounter] = useState(-1);
    const [imgSize, setImgSize] = useState(null);
    const [inSubmit, setInSubmit] = useState(false);
    const [illustrations, setIllustrations] = useState([]);

    useEffect(() => {
        const fetchIllustrations = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/layouts/get`);
            const res = await req.json();

            if (req.status !== 200) return alert("Error server");
            setIllustrations(res);

            if (res.length !== 0) setCounter(0);
        }
        fetchIllustrations();
    }, []);

    useEffect(() => {
        if (!illustrations || illustrations.length === 0 || counter === -1) return setImgSize(null)

        const img = new Image();
        img.src = illustrations[counter].image.url;

        img.onload = () => {
            setImgSize({ width: img.naturalWidth, height: img.naturalHeight });
        };

    }, [illustrations, counter]);

    const prev = () => {
        if (counter === 0) return
        setCounter(counter - 1);
    }

    const next = () => {
        if (counter === illustrations.length - 1) return
        setCounter(counter + 1);
    }

    const addIllustration = async (e) => {
        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        const file = e.target.files[0];
        if (!file) return

        const body = new FormData();
        body.append('image', file);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/layouts/add`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${localStorage.getItem('token_vanrah')}` },
            body: body
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 201) return alert(res.message);
        const newCounter = illustrations.length;

        setIllustrations([...illustrations, res])
        setCounter(newCounter);
    }

    const delIllustration = async () => {
        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        const req = await fetch(`${process.env.REACT_APP_API_URL}/layouts/del/${illustrations[counter]._id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` }
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 200) return alert(res.message);

        if (req.status === 200) {
            const newIllustList = illustrations.filter(i => i._id !== illustrations[counter]._id);
            setIllustrations(newIllustList);
            setCounter(newIllustList.length === 0 ? -1 : counter - 1);
        }
    }

    return (
        <div className="loader">
            <button
                className="close_loader"
                onClick={() => setShowLoader(false)}
            >
                <i className="fas fa-xmark"></i>
            </button>

            <div className="container">
                <p className="title">VanRah</p>
                <p className="subtitle">Original Manga Artist</p>
            </div>

            <div
                className="illustration"
                style={{
                    backgroundImage: imgSize && counter !== -1 ? `url(${illustrations[counter].image.url})` : 'unset',
                    aspectRatio: imgSize && counter !== -1 ? `${imgSize.width} / ${imgSize.height}` : 'unset'
                }}
            >
                {imgSize && counter !== 0 &&
                    <button
                        className="btn_counter btn_left"
                        onClick={() => prev()}
                    ><i className="fas fa-chevron-left"></i></button>
                }

                {imgSize && counter !== illustrations.length - 1 &&
                    <button
                        className="btn_counter btn_right"
                        onClick={() => next()}
                    ><i className="fas fa-chevron-right"></i></button>
                }

                {imgSize &&
                    <button
                        className="edit_loader btn_delete"
                        onClick={() => delIllustration()}
                    ><i className="fas fa-remove"></i></button>
                }

                <button className="edit_loader btn_more">
                    <i className="fas fa-plus"></i>
                    <input
                        type="file"
                        onChange={(e) => addIllustration(e)}
                    />
                </button>
            </div>

            <div className="socials">
                <ul>
                    <li><a href="https://www.facebook.com/VanRah.Sama/" target="blank"><img src={icon_facebook} alt="" /></a></li>
                    <li><a href="https://www.instagram.com/vanrah.sama/?next=%2F" target="blank"><img src={icon_insta} alt="" /></a></li>
                    <li><a href="https://www.youtube.com/@VanRah-Sama" target="blank"><img src={icon_yt} alt="" /></a></li>
                </ul>

                <div className="copyright">
                    <i className="logo_vanrah"></i>

                    <p>
                        Copyright © 2026 VanRah. All rights reserved. <br />
                        Design by : VanRah <br />
                        Developed by : C. Beaudet
                    </p>
                </div>
                
                <ul className="reverse">
                    <li><a href="mailto:vanrah-tegamiden@outlook.com"><img src={icon_email} alt="" /></a></li>
                    <li><a href="https://www.deviantart.com/vanrah" target="blank"><img src={icon_deviantart} alt="" /></a></li>
                    <li><a href="https://www.threads.com/@vanrah.sama" target="blank"><img src={icon_threads} alt="" /></a></li>
                </ul>
            </div>
        </div>
    );
}

export default Loader;